module.exports = __webpack_public_path__ + "img/calendar-black.10282606.svg";